if (!customElements.get('top-restock')) customElements.define('top-restock', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    const dataNode = this.querySelector('[data-restock-data]');
    if (!dataNode) return;
    try { this.data = JSON.parse(dataNode.textContent); } catch (error) {
      console.warn('[Top Pestañas] Invalid restock data', error);
      return;
    }
    this.unavailable = (this.data.variants || []).filter(variant => !variant.available);
    this.trigger = this.querySelector('[data-restock-trigger]');
    // Keep the original dialog when Shopify temporarily detaches and reattaches a product card.
    this.dialog = this.dialog || this.querySelector('dialog');
    if (!this.trigger || !this.dialog || !this.unavailable.length) return;
    this.select = this.dialog.querySelector('[data-restock-variant]');
    this.form = this.dialog.querySelector('[data-restock-form]');
    this.email = this.dialog.querySelector('[data-restock-email]');
    this.status = this.dialog.querySelector('[data-restock-status]');
    this.submit = this.form?.querySelector('[type="submit"]');
    if (!this.select || !this.form || !this.email || !this.status || !this.submit) return;
    this.scope = this.hasAttribute('data-card') ? this :
      (this.closest('.page-content[data-product-id]') || this.closest('[data-product-id]') ||
        document.getElementById('shopify-section-' + this.dataset.section) || this);
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const uid = 'restock-' + (globalThis.crypto?.randomUUID?.() || Math.random().toString(36).slice(2));
    this.dialog.id = uid;
    const heading = this.dialog.querySelector('h2');
    if (heading) { heading.id = uid + '-title'; this.dialog.setAttribute('aria-labelledby', heading.id); }
    this.select.id = uid + '-variant';
    this.email.id = uid + '-email';
    const labels = this.form.querySelectorAll('label');
    if (labels[0]) labels[0].htmlFor = this.select.id;
    if (labels[1]) labels[1].htmlFor = this.email.id;
    this.select.replaceChildren();
    this.unavailable.forEach(variant => this.select.add(new Option(
      variant.title === 'Default Title' ? this.data.title : variant.title, String(variant.id))));
    const sync = () => {
      const picker = !this.hasAttribute('data-card') && this.scope.querySelector('top-lash-order:not([hidden])');
      const shouldHide = Boolean(picker);
      if (this.trigger.hidden !== shouldHide) this.trigger.hidden = shouldHide;
    };
    this.observer = new MutationObserver(sync);
    this.observer.observe(this.scope, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']});
    this.trigger.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      this.open(this.dataset.selected);
    }, {signal});
    if (!this.hasAttribute('data-card')) {
      // Delegation also works after the quick-add modal replaces the product markup.
      document.addEventListener('top:restock', event => {
        if (this.isConnected && this.scope.contains(event.target)) this.open(event.detail?.id);
      }, {signal});
    }
    document.addEventListener(`variant:change:${this.dataset.section}:${this.dataset.product}`, event => {
      const fresh = event.detail?.html?.querySelector('top-restock');
      if (fresh?.dataset.selected) this.dataset.selected = fresh.dataset.selected;
    }, {signal});
    this.dialog.querySelector('[data-restock-close]')?.addEventListener('click', () => this.dialog.close(), {signal});
    this.dialog.addEventListener('close', () => this.opener?.isConnected && this.opener.focus(), {signal});
    this.form.addEventListener('submit', event => this.subscribe(event), {signal});
    document.body.append(this.dialog);
    sync();
  }
  open(id) {
    if (this.busy || !this.dialog?.isConnected) return;
    this.opener = document.activeElement;
    this.form.hidden = false;
    this.status.textContent = '';
    const variant = this.unavailable.find(v => String(v.id) === String(id)) || this.unavailable[0];
    this.select.value = String(variant.id);
    if (!this.dialog.open) this.dialog.showModal();
    this.email.focus();
  }
  async subscribe(event) {
    event.preventDefault();
    if (this.busy || !this.form.reportValidity()) return;
    const variant = this.unavailable.find(v => String(v.id) === this.select.value);
    if (!variant) return;
    this.busy = true;
    this.submit.disabled = true;
    this.select.disabled = true;
    this.status.textContent = this.data.text.sending;
    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.company)}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'revision': '2026-07-15'},
        body: JSON.stringify({data: {type: 'back-in-stock-subscription', attributes: {
          channels: ['EMAIL'], profile: {data: {type: 'profile', attributes: {email: this.email.value.trim()}}}
        }, relationships: {variant: {data: {type: 'catalog-variant', id: `$shopify:::$default:::${variant.id}`}}}}})
      });
      if (!response.ok) {
        console.warn('[Top Pestañas] Back-in-stock request failed with status', response.status);
        throw new Error('subscription');
      }
      this.form.hidden = true;
      this.status.textContent = this.data.text.success;
    } catch (error) {
      this.status.textContent = this.data.text.error;
    } finally {
      this.busy = false;
      this.submit.disabled = false;
      this.select.disabled = false;
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.observer?.disconnect();
    // Retain the dialog instance for re-connection, but remove it from the page for now.
    this.dialog?.remove();
  }
});
